import React from 'react';

const ProgramPresentation = () => {
  const programFeatures = [
    {
      id: 1,
      title: "Apprentissage ludique et pratique",
      description: "Des activités engageantes qui transforment l'apprentissage en expérience amusante et concrète pour les enfants.",
      icon: "🚀",
      color: "bg-purple-3",
      textColor: "text-purple-1"
    },
    {
      id: 2,
      title: "Robotique & programmation accessibles",
      description: "Des outils adaptés aux jeunes élèves pour découvrir les bases du codage et de la robotique sans complexité.",
      icon: "🤖",
      color: "bg-light-2",
      textColor: "text-blue-1"
    },
    {
      id: 3,
      title: "Approche STEAM créative",
      description: "Intégration complète des sciences, technologies, arts et mathématiques dans des projets interdisciplinaires.",
      icon: "🎨",
      color: "bg-light-6",
      textColor: "text-red-2"
    },
    {
      id: 4,
      title: "Supports pédagogiques alignés",
      description: "Un programme conçu pour s'intégrer parfaitement au rythme scolaire et aux objectifs pédagogiques.",
      icon: "📚",
      color: "bg-light-3",
      textColor: "text-dark-1"
    }
  ];

  return (
    <section className="py-16 px-4 md:px-8 lg:px-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-dark-1 mb-4 font-sans">
            Notre programme éducatif innovant
          </h2>
          <p className="text-light-1 text-lg max-w-3xl mx-auto font-sans">
            Découvrez comment Little Maker révolutionne l'apprentissage des technologies créatives à l'école
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {programFeatures.map((feature) => (
            <div 
              key={feature.id} 
              className={`rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300 ${feature.color} border border-white`}
            >
              <div className="flex items-start mb-6">
                <span className="text-4xl mr-5">{feature.icon}</span>
                <h3 className={`text-xl font-bold font-sans ${feature.textColor}`}>
                  {feature.title}
                </h3>
              </div>
              <p className="text-light-1 font-sans text-normal leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Bénéfices supplémentaires */}
        <div className="mt-16 bg-light-4 rounded-2xl p-8 md:p-12">
          <h3 className="text-xl font-bold text-dark-1 mb-6 text-center font-sans">
            Les bénéfices pour votre établissement
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-green-1 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-dark-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <h4 className="font-semibold text-dark-1 mb-2 font-sans">Matériel adapté</h4>
              <p className="text-light-1 text-sm font-sans">Équipement spécialement conçu pour les petites mains</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-1 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                </svg>
              </div>
              <h4 className="font-semibold text-dark-1 mb-2 font-sans">Formation enseignants</h4>
              <p className="text-light-1 text-sm font-sans">Accompagnement complet pour le personnel éducatif</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-1 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </div>
              <h4 className="font-semibold text-dark-1 mb-2 font-sans">Ressources complètes</h4>
              <p className="text-light-1 text-sm font-sans">Guide pédagogique, fiches activités et support technique</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramPresentation;